<template>
  <section class="modals">
    <!-- Portfolio Modal 1-->
    <portfolio-modal-one></portfolio-modal-one>
    <!--Portfolio Modal 2 -->
    <portfolio-modal-two></portfolio-modal-two>
    <!--Portfolio Modal 3 -->
    <portfolio-modal-three></portfolio-modal-three>
  </section>
</template>

<script>
import PortfolioModalOne from "./PortfolioModalOne.vue";
import PortfolioModalTwo from "./PortfolioModalTwo.vue";
import PortfolioModalThree from "./PortfolioModalThree.vue";
export default {
  name: "modal-contents",
  components: { PortfolioModalOne, PortfolioModalTwo, PortfolioModalThree },
};
</script>

<style >
.portfolio-modal .portfolio-modal-title {
  font-size: 1.75rem;
  line-height: 2rem;
}
@media (min-width: 992px) {
  .portfolio-modal .portfolio-modal-title {
    font-size: 2rem;
    line-height: 2.5rem;
  }
}
.portfolio-modal .close {
  position: absolute;
  z-index: 1;
  right: 1.5rem;
  top: 1rem;
  font-size: 3rem;
  line-height: 3rem;
  color: #1abc9c;
  opacity: 1;
}
</style>